import React from 'react';

import { formatCurrency } from '@atc/string-fns';

import { Text } from 'reaxl';

import clsx from 'clsx';

import DigitalRetailOverlayCTA from '../DigitalRetailOverlayCTA';

const pipe = <span className="padding-horizontal-2">|</span>;

function Wrapper({ children, isCompactView = false }) {
    return (
        <div
            className={clsx({
                'margin-vertical-4': isCompactView,
                'margin-bottom-2 margin-top-4': !isCompactView,
            })}
        >
            {children}
        </div>
    );
}

function DealCardVehicleProtection({ dealData, component: Component, isCompactView, ...rest }) {
    if (typeof Component === 'undefined') {
        Component = Wrapper;
    }

    const { vehicle, vehicleProtection = {} } = dealData;
    const { vehicleProtectionProgram } = vehicle;

    const { products, VPPSelectedFlag } = vehicleProtection;
    const hasVehicleProtection = VPPSelectedFlag && products?.length > 0;

    const linkProps = {
        ...rest,
        ...dealData,
        listing: dealData.vehicle,
        listedPrice: dealData.vehicle.sellingPrice,
        route: 'protectionList',
        uiContext: 'dealPanel',
    };

    if (!vehicleProtectionProgram) {
        return null;
    }

    return (
        <Component isCompactView={isCompactView}>
            <Text
                weight="bold"
                className={clsx('display-block', {
                    'margin-bottom-1': isCompactView,
                })}
            >
                Additional Protections
            </Text>
            {hasVehicleProtection ? (
                <>
                    {products?.map((item, index) => (
                        <div
                            key={index}
                            className="display-flex justify-content-between"
                        >
                            <Text>{item.name}</Text>
                            <div>
                                <Text>{formatCurrency(item.price)}</Text>
                                {item.monthly && (
                                    <>
                                        {pipe}
                                        <Text>
                                            {formatCurrency(item.monthly)}
                                            /mo.
                                        </Text>
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                    <div className={clsx({ 'margin-top-1': isCompactView })}>
                        <DigitalRetailOverlayCTA
                            {...linkProps}
                            buttonText="Edit vehicle protections"
                        />
                    </div>
                </>
            ) : (
                <>
                    <Text>
                        We offer a wide variety of coverage and extras to keep money in your pocket and your car on the
                        road.
                    </Text>
                    <div
                        data-cmp="deal-vehicleProtections"
                        className={clsx({ 'margin-top-1': isCompactView })}
                    >
                        <DigitalRetailOverlayCTA
                            {...linkProps}
                            buttonText="Add vehicle protections"
                        />
                    </div>
                </>
            )}
        </Component>
    );
}

export default DealCardVehicleProtection;
